export const AUTH_REDIRECT_DEFAULT_TARGET = "/home/dashboard/";

export interface AuthRedirectAppState {
  target: string;
  targetUrl: string;
}

interface AuthRedirectAppStateInput {
  target?: unknown;
  targetUrl?: unknown;
}

export function getAuthRedirectAppState(target: unknown): AuthRedirectAppState {
  const redirectTarget =
    getValidAuthRedirectTarget(target) ?? AUTH_REDIRECT_DEFAULT_TARGET;

  return {
    target: redirectTarget,
    targetUrl: redirectTarget,
  };
}

export function getAuthRedirectTarget(
  appState?: AuthRedirectAppStateInput | null,
): string | null {
  return (
    getValidAuthRedirectTarget(appState?.targetUrl) ??
    getValidAuthRedirectTarget(appState?.target)
  );
}

export function getValidAuthRedirectTarget(target: unknown): string | null {
  if (typeof target !== "string") {
    return null;
  }

  const trimmedTarget = target.trim();

  if (!trimmedTarget.startsWith("/") || trimmedTarget.startsWith("//")) {
    return null;
  }

  return trimmedTarget;
}

export function getSafeBrowserAuthRedirectUrl(target: unknown): string | null {
  if (typeof target !== "string") {
    return null;
  }

  const trimmedTarget = target.trim();

  if (!trimmedTarget) {
    return null;
  }

  try {
    const redirectUrl = new URL(trimmedTarget);

    if (
      redirectUrl.origin !== window.location.origin ||
      !["http:", "https:"].includes(redirectUrl.protocol)
    ) {
      return null;
    }

    return redirectUrl.href;
  } catch {
    return null;
  }
}
